import {ReactElement} from "react";
import styled from "styled-components";

import IconDownload from "@/assets/iconDownload.svg?react";
import IconTrash from "@/assets/iconTrash.svg?react";
import {quicksandMedium, quicksandSemiBold} from "@/GlobalStyle";
import {useLoadingState} from "@/hooks/useLoadingState/useLoadingState";

import {Button} from "../Button/Button";
import {ErrorMessage} from "../ErrorMessage/ErrorMessage";
import Loader from "../Loader/Loader";

const FichierEnvoyeStyled = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin: 15px 0;
  & p {
    margin: 0;
    font-size: 1.25rem;
    ${quicksandSemiBold}
    color: ${({theme}) => theme.colors.darkPrimary};
  }
  & span {
    font-size: 1.25rem;
    ${quicksandMedium}
    color: ${({theme}) => theme.colors.mediumPrimary};
  }
  & svg {
    width: 1.5rem;
    fill: ${({theme}) => theme.colors.darkPrimary};
  }
`;

export function FichierEnvoye({
  fileName,
  fileNameComplement,
  icon,
  handleRemoveFile,
  handleDownloadFile,
}: {
  fileName: string;
  fileNameComplement: string;
  icon: ReactElement;
  handleRemoveFile: () => Promise<void>;
  handleDownloadFile?: () => Promise<void>;
}): ReactElement {
  const DeleteFileLoadingState = useLoadingState();
  const DownloadFileLoadingState = useLoadingState();
  return (
    <>
      <FichierEnvoyeStyled>
        {icon}
        <p>
          {`${fileName} `}
          <span>{fileNameComplement}</span>
        </p>
        <Button
          icon={
            DeleteFileLoadingState.isLoading ? (
              <Loader isIcon={true} color="white" />
            ) : (
              IconTrash
            )
          }
          variant="negate"
          disabled={DeleteFileLoadingState.isLoading}
          onClick={async () => {
            await DeleteFileLoadingState.executeWithLoading(async () => {
              await handleRemoveFile();
            });
          }}
        />
        {handleDownloadFile && (
          <Button
            icon={
              DownloadFileLoadingState.isLoading ? (
                <Loader isIcon={true} color="white" />
              ) : (
                IconDownload
              )
            }
            variant="secondary"
            disabled={DownloadFileLoadingState.isLoading}
            onClick={async () => {
              await DownloadFileLoadingState.executeWithLoading(async () => {
                await handleDownloadFile();
              });
            }}
          />
        )}
      </FichierEnvoyeStyled>
      {DeleteFileLoadingState.hasError ? (
        <ErrorMessage text={DeleteFileLoadingState.error} />
      ) : null}
    </>
  );
}
